import { Route } from 'react-router';
import { Page } from '@roc/feature-app-core';
import { InsuranceAgentFinder } from '../components/insuranceAgentFinder';
import { InsuranceCarrierDashboard } from '../components/insuranceCarrierDashboard';

export const getInsuranceAgentRoutesConfig = (
  basePath: string,
  baseUrl: string
) => {
  return {
    insuranceAgentDashboard: {
      path: `${basePath}/backoffice/insurance-agents`,
      url: `${baseUrl}/backoffice/insurance-agents`,
    },
  };
};

export const getInsuranceAgentRoutes = (basePath: string, baseUrl: string) => {
  const config = getInsuranceAgentRoutesConfig(basePath, baseUrl);

  return {
    insuranceAgentDashboard: (
      <Route exact path={config.insuranceAgentDashboard.path}>
        <Page routeDefinition={config.insuranceAgentDashboard}>
          <InsuranceAgentFinder />
        </Page>
      </Route>
    ),
  };
};

export const getInsuranceCarrierRoutesConfig = (
  basePath: string,
  baseUrl: string
) => {
  return {
    insuranceCarrierDashboard: {
      path: `${basePath}/insurance-carriers`,
      url: `${baseUrl}/insurance-carriers`,
    },
  };
};

export const getInsuranceCarrierRoutes = (basePath: string, baseUrl: string) => {
  const config = getInsuranceCarrierRoutesConfig(basePath, baseUrl);

  return {
    insuranceCarrierDashboard: (
      <Route exact path={config.insuranceCarrierDashboard.path}>
        <Page routeDefinition={config.insuranceCarrierDashboard}>
          <InsuranceCarrierDashboard />
        </Page>
      </Route>
    ),
  };
};
